import { Component } from '@angular/core';

@Component({
  selector: 'app-brand-logo',
  template: ` <a routerLink="/" class="nav-brand-logo" title="UMANG">
<img
      src="https://media.umangapp.in/cdn/landing/theme/icons/logo.svg"
      alt="UMANG"
      width="191px"
      height="55px"
      loading="lazy"
      fetchpriority="high"
      class="light-mode-umg"
      
    />
    <img
      src="https://media.umangapp.in/cdn/landing/theme/icons/logo-white.svg"
      alt="UMANG"
      width="191px"
      height="55px"
      loading="lazy"
      fetchpriority="high"
      class="dark-mode-umg"
      
    />
  </a>`,
})
export class BrandLogoComponent {
  constructor() {}
}
